// extracted by mini-css-extract-plugin
export default {"wrapper":"RegionPage_wrapper__PYmLP","section":"RegionPage_section__85zrC","flex":"RegionPage_flex__Gmj77","button":"RegionPage_button__K1qY6","image":"RegionPage_image__quNoI"};